import { useMemo } from "react";
import clsx from "clsx";
import {
  defaultPhoneCountry,
  findPhoneCountryByCode,
  PHONE_COUNTRIES,
} from "@/lib/phoneCountries";

type Props = {
  value: string;
  onChange: (value: string) => void;
  required?: boolean;
  missing?: boolean;
  className?: string;
  autoComplete?: string;
};

export function CountrySelect({
  value,
  onChange,
  required = false,
  missing = false,
  className,
  autoComplete = "country",
}: Props) {
  const sortedCountries = useMemo(
    () => [...PHONE_COUNTRIES].sort((a, b) => a.name.localeCompare(b.name, "de")),
    [],
  );
  const selectedCode = (value || defaultPhoneCountry().code).toUpperCase().slice(0, 2);

  return (
    <select
      className={clsx("bk-input mt-1", className, missing && "bk-input--missing")}
      value={selectedCode}
      onChange={(e) => onChange(e.target.value.toUpperCase())}
      required={required}
      aria-invalid={missing || undefined}
      autoComplete={autoComplete}
    >
      {sortedCountries.map((country) => (
        <option key={country.code} value={country.code}>
          {country.flag} {country.name} ({country.code})
        </option>
      ))}
      {!findPhoneCountryByCode(selectedCode) ? (
        <option value={selectedCode}>{selectedCode}</option>
      ) : null}
    </select>
  );
}
